// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-table[data-v-1bcbfcf4]{box-sizing:border-box}.baikeCat .el-select[data-v-1bcbfcf4]{width:48%;float:left}.ellips[data-v-1bcbfcf4]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
